/*
 *
 * OnboardingContainer reducer
 *
 */
import produce from 'immer';

import { setItemsInLocalStorage } from 'utils/common';
import { EMAIL_LOGIN } from 'utils/constants';

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  DEFAULT_STATUS,
  SAVE_USER_DETAILS,
  SAVE_MERCHANT_DETAILS,
  UPDATE_FORM_STATUS,
  UPDATE_LOGIN_FORM,
  RESET_DATA,
  VALIDATE_TOKEN_SUCCESS,
  TOGGLE_OTP_MODAL,
  STORE_ERROR_LOGIN,
  SET_SIGNUP_FIRST_STEP_DATA,
} from './constants';

const getInitialState = () => ({
  isLoading: false,
  signUpFormStatus: DEFAULT_STATUS,
  loginForm: EMAIL_LOGIN,
  isFormSubmitted: false,
  userDetails: {
    email: '',
    password: '',
  },
  merchantDetails: {
    countryCode: '+91',
    phone: '',
    appType: 'business_page',
    merchantSiteUrl: '',
    whatsappConsent: '0',
  },
  emailLogin: {
    email: '',
    password: '',
  },
  aliasLogin: {
    accountAlias: '',
    username: '',
    password: '',
  },
  otp2faModal: false,
  active2faMethodData: {},
  signupFirstStepData: {
    googleToken: '', // available in case of google signup
    email: '',
    password: '',
    channel: '',
    deviceId: '',
    termsId: '',
  },
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const onboardingContainerReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case UPDATE_FORM_STATUS: {
        draft.signUpFormStatus = action.data;
        break;
      }
      case UPDATE_LOGIN_FORM: {
        draft.loginForm = action.data;
        break;
      }
      case SAVE_USER_DETAILS: {
        Object.keys(action.data).forEach(key => {
          if (key in draft.userDetails)
            draft.userDetails[key] = action.data[key];
        });

        const cfTokenObj = { prod: action.data };
        setItemsInLocalStorage({
          merchantToken: action.data.token,
          email: draft.userDetails.email,
          userFlow: 'login',
          cfToken: JSON.stringify(cfTokenObj),
        });
        break;
      }
      case SAVE_MERCHANT_DETAILS: {
        Object.keys(action.data).forEach(key => {
          if (key in draft.merchantDetails)
            draft.merchantDetails[key] = action.data[key];
        });

        draft.isFormSubmitted = true;

        setItemsInLocalStorage({
          userFlow: 'landing',
        });
        break;
      }
      case RESET_DATA: {
        /**
         * Onboarding container dispatches this action on every path change,
         * We have to prevent Signup form status for users whose Step-1 is complete and should be redirected to
         * Signup Step-2 directly.
         * Hence when path changes to Signup, do not reset Signup form related data, else reset all
         */
        const isSignupPage = window.location.pathname.includes('signup');
        console.log('isSignupPage', isSignupPage);
        let stateToReset = {};
        if (isSignupPage) {
          const {
            signUpFormStatus,
            signupFirstStepData,
            ...obj
          } = getInitialState();
          stateToReset = obj;
        } else {
          stateToReset = getInitialState();
        }
        Object.keys(stateToReset).forEach(k => (draft[k] = stateToReset[k])); // eslint-disable-line
        break;
      }
      case VALIDATE_TOKEN_SUCCESS: {
        const { merchantId, email } = action.data;
        if (merchantId) setItemsInLocalStorage({ merchantId });
        if (email) setItemsInLocalStorage({ email });
        break;
      }
      case TOGGLE_OTP_MODAL: {
        draft.otp2faModal = action.data;
        break;
      }
      case STORE_ERROR_LOGIN: {
        draft.active2faMethodData = action.data.data;
        break;
      }
      case SET_SIGNUP_FIRST_STEP_DATA: {
        draft.signupFirstStepData = action.data;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default onboardingContainerReducer;
